import React from "react";
import PropTypes from "prop-types";
import { Isvg } from "../../components";

class TOCLevel extends React.Component {
  constructor(props) {
    super(props);
    this._goToPage = this._goToPage.bind(this);
    this._drillDown = this._drillDown.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.hasPageNumber = this.props.info.page;
  }

  _goToPage(e) {
    this.props.goToPage(
      this.props.info.cfi,
      this.props.info.page,
      this.props.info.path,
      e
    );
  }

  _drillDown() {
    this.props.drillDown(this.props.info);
  }

  _onClickLevelHandler(hasDrill, e) {
    if (hasDrill) {
      this._drillDown();
    } else {
      this._goToPage(e);
    }
  }

  render() {
    const hasDrill = this.props.drillDown && this.props.info.children.length;
    let arrow =
      (this.props.info.children &&
        this.props.info.children.length &&
        this.props.drillDown &&
        !this.props.showingResults &&
        " arrow") ||
      "";
    return (
      <li
        data-activekey={this.props.activekey}
        className={
          "toc-level level-" +
          this.props.info.level +
          " group" +
          (this.props.info.titleNode ? " title" : "")
        }
      >
        <button
          className={"section" + arrow}
          onClick={e => {
            this._onClickLevelHandler(hasDrill, e);
          }}
        >
          <div title={this.props.info.title}>
            {this.props.hasPages && (
              <div title={this.props.info.page} className="page">
                <span className="hidden-page">{i18n.t("reader.toc.page")}</span>
                {this.props.info.page}
              </div>
            )}
            <div className={"title" + (this.props.hasPages ? "" : " no-pages")}>
              {this.props.info.title}
            </div>
          </div>
        </button>
      </li>
    );
  }
}

TOCLevel.propTypes = {
  activekey: PropTypes.string.isRequired,
  goToPage: PropTypes.func.isRequired,
  drillDown: PropTypes.func.isRequired,
  hasPages: PropTypes.bool,
  info: PropTypes.shape({
    cfi: PropTypes.string,
    title: PropTypes.string,
    page: PropTypes.string,
    titleNode: PropTypes.bool,
    path: PropTypes.string,
    level: PropTypes.number,
    children: PropTypes.array
  }).isRequired
};

TOCLevel.defaultProps = {
  hasPages: false
};

module.exports = TOCLevel;
